import { State } from "../../types";
import { extractKeysAndIndexes } from "../getDefaultState";

export type UpdatePointPromptAction = Readonly<{
  key: string;
  type: "UPDATE POINT PROMPT";
  prompt: string;
}>;

export const updatePointPrompt = (state: State, action: UpdatePointPromptAction): State => {
  if (!(action.key in state.values)) {
    return state;
  }
  let newTaxo = {
    ...state.taxonomy
  }
  let point = extractKeysAndIndexes(action.key, newTaxo.taxonomyObject);
  point.taxonomyEntry.prompt = action.prompt;
;
  return {
    ...state,
    taxonomy: newTaxo
  }
};
